import {
  Box,
  Button,
  Grid,
  makeStyles,
  Menu,
  MenuItem,
  Paper,
  Select,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@material-ui/core";
import React, { useState, useEffect } from "react";
import downSvg from "../images/dataanalytics/down.svg";
import ChooseStepTwo from "./ChooseStepTwo";
import MapContainer from "./MapContainer";
import DateRangePicker from "../Components/DateRangePicker";
import { fetchSebiAnalyticsData } from "../api/sebiAnalyticsApi";
import CircularCenteredLoader from "features/common/CircularCenteredLoader";
import RedactedAwards from "./RedactedAwards";
import Neutrals from "./Neutrals";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "4rem 7rem",
    [theme.breakpoints.down('md')]:{
      padding: "40px",
    },
    [theme.breakpoints.down('sm')]:{
      padding: "30px",
    },
    [theme.breakpoints.down('sm')]:{
      padding: "20px",
    }
  },
  paperitem: {
    padding: "1rem",
    textAlign: "center",
    cursor: "pointer",
  },
  selectedpaper: {
    padding: "1rem",
    textAlign: "center",
    background: "#edf4fe",
    // opacity: "0.12",
  },
  textitem: {
    fontSize: "20px",
    color: "#333333",
  },
  select: {
    marginTop: "0.5rem",
    width: "100%",
    background: "#4F4F4F",
    borderRadius: "4px",
    color: "#ffffff",
    textTransform: "none",
    padding: "10px",
    "&:hover": {
      background: "#4F4F4F",
    },
  },
  icon: {
    fill: "#ffffff",
  },
  menu: {
    width: "100%",
  },
  customDialog: {
    minWidth: "400px",
  },
  dialogContent: {
    paddingTop: "1.5rem",
  },
}));

const defaultAnalyticsData = {
  "result": {
    "total_dispute_recieved": 0,
    "dispute_resolved": 0,
    "dispute_resolved_in_conciliation": 0,
    "dispute_resolved_in_arbitration": 0,
    "successful_conciliation": 0,
    "unsuccessful_conciliation": 0,
    "arbitrations": {
      "total": 0,
      "in_favour_of_claimant": 0,
      "in_favour_of_market_participant": 0,
      "settlement_awards": 0,
      "in_progress": 0,
    },
    "state_wise": [
  { id: "AP", state: "Andhra Pradesh", value: [0, 0, 0] },
  { id: "AR", state: "Arunachal Pradesh", value: [0, 0, 0] },
  { id: "AS", state: "Assam", value: [0, 0, 0] },
  { id: "BR", state: "Bihar", value: [0, 0, 0] },
  { id: "CT", state: "Chhattisgarh", value: [0, 0, 0] },
  { id: "GA", state: "Goa", value: [0, 0, 0] },
  { id: "GJ", state: "Gujarat", value: [0, 0, 0] },
  { id: "HR", state: "Haryana", value: [0, 0, 0] },
  { id: "HP", state: "Himachal Pradesh", value: [0, 0, 0] },
  { id: "JH", state: "Jharkhand", value: [0, 0, 0] },
  { id: "KA", state: "Karnataka", value: [0, 0, 0] },
  { id: "KL", state: "Kerala", value: [0, 0, 0] },
  { id: "MP", state: "Madhya Pradesh", value: [0, 0, 0] },
  { id: "MH", state: "Maharashtra", value: [0, 0, 0] },
  { id: "MN", state: "Manipur", value: [0, 0, 0] },
  { id: "ML", state: "Meghalaya", value: [0, 0, 0] },
  { id: "MZ", state: "Mizoram", value: [0, 0, 0] },
  { id: "NL", state: "Nagaland", value: [0, 0, 0] },
  { id: "PB", state: "Punjab", value: [0, 0, 0] },
  { id: "RJ", state: "Rajasthan", value: [0, 0, 0] },
  { id: "SK", state: "Sikkim", value: [0, 0, 0] },
  { id: "TN", state: "Tamil Nadu", value: [0, 0, 0] },
  { id: "TR", state: "Tripura", value: [0, 0, 0] },
  { id: "UP", state: "Uttar Pradesh", value: [0, 0, 0] },
  { id: "WB", state: "West Bengal", value: [0, 0, 0] },
  { id: "AN", state: "Andaman and Nicobar Islands", value: [0, 0, 0] },
  { id: "CH", state: "Chandigarh", value: [0, 0, 0] },
  { id: "DN", state: "Dadra and Nagar Haveli", value: [0, 0, 0] },
  { id: "DD", state: "Daman and Diu", value: [0, 0, 0] },
  { id: "DL", state: "Delhi", value: [0, 0, 0] },
  { id: "JK", state: "Jammu and Kashmir", value: [0, 0, 0] },
  { id: "LA", state: "Ladakh", value: [0, 0, 0] },
  { id: "LD", state: "Lakshadweep", value: [0, 0, 0] },
  { id: "PY", state: "Puducherry", value: [0, 0, 0] },
  { id: "TS", state: "Telangana", value: [0, 0, 0] },
  { id: "UK", state: "Uttarakhand", value: [0, 0, 0] },
  { id: "OD", state: "Odisha", value: [0, 0, 0] },
  { id: "-99", state: "Andhra Pradesh", value: [0, 0, 0] },
]
  }
};

export default function DataAnalytics({
  type,
  setType,
  choosestep2,
  setChoosestep2,
  data,
  states,
  stateLists,
  stateOnClick,
  activeState,
  setactiveState,
}) {
  const classes = useStyles();
  const rangeValues = ["1 Year", "6 Months", "3 Months"];
  const [range, setRange] = useState("1 Year");

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const [openCustomDialog, setOpenCustomDialog] = useState(false);
  const [customStartDate, setCustomStartDate] = useState(null);
  const [customEndDate, setCustomEndDate] = useState(null);
  const [analyticsData, setAnalyticsData] = useState(defaultAnalyticsData);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const loadAnalyticsData = async (from_date, to_date) => {
    try {
      setLoading(true);
      setAnalyticsData(type === 'analytics' ? defaultAnalyticsData : null);
      const params = { 
        type, 
        to_date, 
        from_date, 
      };
      const data = await fetchSebiAnalyticsData(params);
      setAnalyticsData(data);
      setError(null);
    } catch (err) {
      console.error("Failed to fetch analytics data:", err);
      setError(err.message);
      setAnalyticsData(defaultAnalyticsData);
    } finally {
      setLoading(false);
    }
  };

  // Fetch analytics data on component mount
  useEffect(() => {

    loadAnalyticsData();
  }, [type]);

  const analyticsTypes = [
    {
      id: 'analytics',
      label: "Analytics",
    },
    {
      id: 'redacted_awards',
      label: "Redacted Awards",
    },
    {
      id: 'neutrals',
      label: "Neutrals",
    },
  ];

  const handleClickAnalyticsType = (id) => {
    setType(id);
    if (id === 'analytics') {
      setChoosestep2(true);
    } else {
      setChoosestep2(false);
    }
    setactiveState();
  }

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleCustomDateOpen = () => {
    setOpenCustomDialog(true);
    handleClose();
  };

  const handleCustomDateClose = () => {
    setOpenCustomDialog(false);
  };

  // Helper function to calculate date range and format dates
  const calculateDateRange = (rangeType) => {
    const today = new Date();
    let fromDate = new Date();

    switch (rangeType) {
      case "1 Year":
        fromDate.setFullYear(today.getFullYear() - 1);
        break;
      case "6 Months":
        fromDate.setMonth(today.getMonth() - 6);
        break;
      case "3 Months":
        fromDate.setMonth(today.getMonth() - 3);
        break;
      default:
        return { fromDate: null, toDate: null };
    }

    return {
      fromDate: fromDate.toLocaleDateString("en-CA"), // Format as YYYY-MM-DD
      toDate: today.toLocaleDateString("en-CA"),
    };
  };

  // Handle date range filter clicks
  const handleDateRangeClick = (rangeValue) => {
    if (rangeValue === "All Time") {
      // Clear date filter
      setRange("All Time");
      handleClose();
      loadAnalyticsData(); // Call without date parameters
    } else {
      const { fromDate, toDate } = calculateDateRange(rangeValue);
      if (fromDate && toDate) {
        setRange(rangeValue);
        handleClose();
        loadAnalyticsData(fromDate, toDate);
      }
    }
  };

  const handleApplyCustomDate = () => {
    if (customStartDate && customEndDate) {
      const startStr = customStartDate.toLocaleDateString("en-CA");
      const endStr = customEndDate.toLocaleDateString("en-CA");
      setRange(`${startStr} - ${endStr}`);
      setOpenCustomDialog(false);
      loadAnalyticsData(startStr, endStr);
    }
  };

  return (
    <Box className={classes.root}>
      <Grid container>
        <Grid item md={8} sm={9} xs={12}>
          <Grid container justify="flex-start" wrap="wrap" spacing={3}>
            {analyticsTypes.map((item) => (
              <Grid
                key={item.id}
                item
                md={4}
                sm={6}
                xs={12}
                style={{ display: "flex" }}
              >
                <Paper
                  style={{ width: "100%" }}
                  className={
                    type === item.id
                      ? classes.selectedpaper
                      : classes.paperitem
                  }
                  onClick={() => handleClickAnalyticsType(item.id)}
                >
                  <Typography className={classes.textitem}>
                    {item.label}
                  </Typography>
                </Paper>
              </Grid>
            ))}
          </Grid>
        </Grid>
        <Grid item md={4} sm={3} xs={12}>
          <Grid container justify="flex-end">
            <Grid item md={4} sm={5} xs={5}>
              <Button
                className={classes.select}
                onClick={(e) => {
                  handleClick(e);
                }}
              >
                {range} &nbsp;&nbsp;&nbsp;&nbsp;
                <img src={downSvg} />
              </Button>
              <Menu
                id="range-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                  "aria-labelledby": "basic-button",
                }}
                className={classes.menu}
              >
                <MenuItem
                  onClick={() => handleDateRangeClick("All Time")}
                >
                  All Time
                </MenuItem>
                {rangeValues.map((value) => (
                  <MenuItem
                    key={value}
                    onClick={() => handleDateRangeClick(value)}
                    value={value}
                  >
                    {value}
                  </MenuItem>
                ))}
                <MenuItem onClick={handleCustomDateOpen}>
                  Custom
                </MenuItem>
              </Menu>
              <Dialog
                open={openCustomDialog}
                onClose={handleCustomDateClose}
                classes={{ paper: classes.customDialog }}
              >
                <DialogTitle>Select Custom Date Range</DialogTitle>
                <DialogContent className={classes.dialogContent}>
                  <DateRangePicker
                    startDate={customStartDate}
                    setStartDate={setCustomStartDate}
                    endDate={customEndDate}
                    setEndDate={setCustomEndDate}
                    maximumEndDate={new Date()}
                    minimumEndDate={new Date('01/01/2020')}
                    maximumStartDate={new Date()}
                    minimumStartDate={new Date('01/01/2020')}
                  />
                </DialogContent>
                <DialogActions>
                  <Button size="small" onClick={handleCustomDateClose}>
                    Cancel
                  </Button>
                  <Button
                    size="small"
                    onClick={handleApplyCustomDate}
                    color="primary"
                    variant="contained"
                    disabled={!customStartDate || !customEndDate}
                  >
                    Apply
                  </Button>
                </DialogActions>
              </Dialog>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      {loading || error ? (
        <>
          {loading && (
            <Box style={{ marginTop: "2rem" }}>
              <CircularCenteredLoader/>
            </Box>
          )}
          {error && (
            <Box style={{ marginTop: "2rem" }}>
              <Typography color="error">Error: {error}</Typography>
            </Box>
          )}
        </>
      ) : (
        <>
          {type === 'analytics' && (
            <>
              <ChooseStepTwo
                choosestep2={choosestep2}
                setChoosestep2={setChoosestep2}
                data={analyticsData?.result}
              />
              <MapContainer
                states={analyticsData?.result?.state_wise}
                stateLists={analyticsData?.result?.state_wise}
                stateOnClick={stateOnClick}
                activeState={activeState}
                choosestep2={choosestep2}
                data={analyticsData?.result}
                stateWiseData={analyticsData?.result?.state_wise}
              />
            </>
          )}
          
          {type === 'redacted_awards' && (
            <>
              <RedactedAwards analyticsData={analyticsData?.data} />
            </>
          )}
          
          {type === 'neutrals' && (
            <>
              <Neutrals neutralsData={analyticsData} />
            </>
          )}
        </>
      )}
    </Box>
  );
}
